import { useDispatch, useSelector } from "react-redux";
import { activeChapterValue } from "../redux/slice/ActiveChapterSlice";

function useChooseChapter() {
  const dispatch = useDispatch();

  // Redux'tan güncel değerleri alıyoruz
  const chapterInfo = useSelector((state) => state.chapterValue.value);
  const selection = chapterInfo.chapter;
  const title = chapterInfo.title;
  const activeId = chapterInfo.activeId || 1; // Aktif butonu takip etmek için

  // Ortak Dispatch Fonksiyonu (Kod tekrarını önlemek için)
  const updateRedux = (chapter, title, id) => {
    dispatch(
      activeChapterValue({
        chapter: chapter,
        title: title,
        activeId: id,
      }),
    );
  };

  // --- CLASS 2 ---
  const chooseClass2Chapter = (id) => {
    switch (id) {
      case 1:
        updateRedux("words", "Words", id);
        break;
      case 2:
        updateRedux("friends", "Friends", id);
        break;
      case 3:
        updateRedux("in_the_classroom", "In The Classroom", id);
        break;
      case 4:
        updateRedux("numbers", "Numbers", id);
        break;
      case 5:
        updateRedux("colors", "Colors", id);
        break;
      case 6:
        updateRedux("at_the_playground", "At The Playground", id);
        break;
      case 7:
        updateRedux("body_parts", "Body Parts", id);
        break;
      case 8:
        updateRedux("pets", "Pets", id);
        break;
      case 9:
        updateRedux("fruit", "Fruit", id);
        break;
      case 10:
        updateRedux("animals", "Animals", id);
        break;
      default:
        console.warn("Geçersiz Class 2 seçimi");
    }
  };

  // --- CLASS 3 ---
  const chooseClass3Chapter = (id) => {
    switch (id) {
      case 1:
        updateRedux("greetings", "Greetings", id);
        break;
      case 2:
        updateRedux("my_family", "My Family", id);
        break;
      case 3:
        updateRedux("people_I_love", "People I Love", id);
        break;
      case 4:
        updateRedux("feelings", "Feelings", id);
        break;
      case 5:
        updateRedux("toys_and_games", "Toys and Games", id);
        break;
      case 6:
        updateRedux("my_house", "My House", id);
        break;
      case 7:
        updateRedux("in_my_city", "In My City", id);
        break;
      case 8:
        updateRedux("transportation", "Transportation", id);
        break;
      case 9:
        updateRedux("weather", "Weather", id);
        break;
      case 10:
        updateRedux("nature", "Nature", id);
        break;
      default:
        console.warn("Geçersiz Class 3 seçimi");
    }
  };

  // --- CLASS 4 ---
  const chooseClass4Chapter = (id) => {
    switch (id) {
      case 1:
        updateRedux("classroom_rules", "Classroom Rules", id);
        break;
      case 2:
        updateRedux("nationality", "Nationality", id);
        break;
      case 3:
        updateRedux("cartoon_characters", "Cartoon Characters", id);
        break;
      case 4:
        updateRedux("free_time", "Free Time", id);
        break;
      case 5:
        updateRedux("my_day", "My Day", id);
        break;
      case 6:
        updateRedux("fun_with_science", "Fun With Science", id);
        break;
      case 7:
        updateRedux("jobs", "Jobs", id);
        break;
      case 8:
        updateRedux("my_clothes", "My Clothes", id);
        break;
      case 9:
        updateRedux("my_friends", "My Friends", id);
        break;
      case 10:
        updateRedux("food_and_drinks", "Food And Drinks", id);
        break;
      default:
        console.warn("Geçersiz Class 4 seçimi");
    }
  };

  const chooseExtra = (id) => {
    switch (id) {
      case 0:
        updateRedux("home", "ana sayfa", id);
        break;
      case 1:
        updateRedux("True & False", "Doğru & Yanlış", id);
        break;
      case 2:
        updateRedux("Listen & Find", "Dinle & Bul", id);
        break;
      case 3:
        updateRedux("Question & Answer", "Soru & Cevap", id);
        break;
      case 4:
        updateRedux("Description", "tanımlama", id);
        break;
      default:
        console.warn("Geçersiz Class 4 seçimi");
    }
  };

  return {
    chooseClass2Chapter,
    chooseClass3Chapter,
    chooseClass4Chapter,
    chooseExtra,
    selection,
    title,
    activeId, // Artık componentlerde 'activeId'yi kullanmalısın
  };
}

export default useChooseChapter;
